<template>
  <main-layout>
    <div class="buttons is-pulled-right">
      <router-link
        class="button is-success is-small"
        :to="{ name: 'courseTypes.create' }"
      >
        Nuovo
      </router-link>
    </div>
    <h1 class="title">Tipologie corsi</h1>

    <api-table :fetch-action="fetch" :items-getter="getter" :page-size="1000">
      <template slot-scope="props">
        <b-table-column field="id" label="ID" width="40" sortable numeric>
          {{ props.row.id }}
        </b-table-column>

        <b-table-column field="code" label="Codice" sortable>
          <b>
            <router-link
              :to="{ name: 'courseTypes.show', params: { id: props.row.id } }"
            >
              {{ props.row.code }}
            </router-link>
          </b>
        </b-table-column>

        <b-table-column field="modified" label="Modificato" sortable centered>
          <b-tooltip
            :label="new Date(props.row.modified).toLocaleString('it-IT')"
            type="is-dark"
            position="is-right"
            animated
          >
            <span class="tag is-light">
              <timeago :datetime="props.row.modified" :auto-update="60" />
            </span>
          </b-tooltip>
        </b-table-column>

        <b-table-column label="Azioni" width="200">
          <div class="buttons">
            <router-link
              :to="{ name: 'courseTypes.show', params: { id: props.row.id } }"
              class="button is-small is-info"
            >
              <span>Mostra</span>
            </router-link>
            <delete-button
              :id="props.row.id"
              :submit-action="destroy"
              @done="fetch()"
            />
            <!-- <router-link
              :to="{ name: 'courseTypes.edit', params: { id: props.row.id }}"
              class="button is-small">
              <span class="icon">
                <i class="fas fa-edit" />
              </span>
              <span>Modifica</span>
            </router-link> -->
          </div>
        </b-table-column>
      </template>
    </api-table>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"

import MainLayout from "@/layouts/Main"
import DeleteButton from "@/components/DeleteButton"

export default {
  components: {
    MainLayout,
    DeleteButton
  },
  data() {
    return {
      search: ""
    }
  },
  methods: {
    fetch: call("courseTypes/all"),
    getter: get("courseTypes/courseTypes"),
    destroy: call("courseTypes/destroy")
  }
}
</script>
